export const tiers = [
    {
        title: 'Bronze',
        price: '50',
        description: [
            '15% transaction fee',
            '14 day payout delay',
            'Basic support',
            '0 professionally hosted Discovery Calls',
        ],
        buttonText: 'Subscribe to Bronze',
        buttonVariant: 'contained',
    },
    {
        title: 'Silver',
        price: '250',
        description: [
            '10% transaction fee',
            '7 day payout delay',
            'Basic support',
            '0 professionally hosted Discovery Calls',
        ],
        buttonText: 'Subscribe to Silver',
        buttonVariant: 'contained',
    },
    {
        title: 'Gold',
        price: '500',
        description: [
            '8% transaction fee',
            '0 day payout delay',
            'Priority support',
            '1 professionally hosted Discovery Call',
        ],
        buttonText: 'Subscribe to Gold',
        buttonVariant: 'contained',
    },
    {
        title: 'Platinum',
        subheader: 'Lowest transaction fee',
        price: '1500',
        description: [
            '5% transaction fee',
            'Immediate payouts',
            'Priority support + Slack support',
            '2 professionally hosted Discovery Calls',
        ],
        buttonText: 'Subscribe to Platinum',
        buttonVariant: 'contained',
    },
    // {
    //     title: 'Enterprise',
    //     price: '',
    //     description: [
    //         'Contact our sales team for a custom plan that fits your needs.',
    //         'Priority support + Slack channel',
    //     ],
    //     buttonText: 'Contact Sales',
    //     buttonVariant: 'outlined',
    // },
];

interface Limit {
    title: string,
    campaigns: number,
    maxGoal: number,
    maxDonorsPerCampaign: number,
    support: 'basic' | 'priority'
}

export const limits: Limit[] = [
    {
        title: 'Starter',
        campaigns: 1,
        maxGoal: 50000,
        maxDonorsPerCampaign: 100,
        support: 'basic'
    },
    {
        title: 'Pro',
        campaigns: 3,
        maxGoal: 250000,
        maxDonorsPerCampaign: 500,
        support: 'priority'
    },
    {
        title: 'Enterprise',
        campaigns: 1000,
        maxGoal: 100000000,
        maxDonorsPerCampaign: 100000,
        support: 'priority'
    }
]